export default "__VITE_ASSET__VXyoC$FI__"